import * as Sentry from '@sentry/browser';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { IntlProps } from '../../';

interface ErrorWrapperState {
    eventId: any; // tslint:disable-line
    hasError: boolean;
}

interface ErrorWrapperProps {
    children: React.ReactNode;
}

type ErrorProps = ErrorWrapperProps & IntlProps;

class HandleErrorWrapper extends React.Component<ErrorProps, ErrorWrapperState> {
    constructor(props: any) {
        super(props);

        this.state = {
            eventId: null,
            hasError: false,
        };
    }

    public static getDerivedStateFromError() {
        return { hasError: true };
    }

    public componentDidCatch(error: any, info: any) {
        Sentry.withScope((scope) => {
            scope.setExtras(info);
            const eventId = Sentry.captureException(error);
            this.setState({ eventId });
        });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <button onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}>
                    {this.props.intl.formatMessage({ id: 'sentry.report_feedback' })}
                </button>
            );
        }

        return this.props.children;
    }
}

export const ErrorWrapper = injectIntl(HandleErrorWrapper);
